import { render, staticRenderFns } from "./mo-input-field.html?vue&type=template&id=5754b456&external"
import script from "./mo-input-field.ts?vue&type=script&lang=ts&external"
export * from "./mo-input-field.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/3/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5754b456')) {
      api.createRecord('5754b456', component.options)
    } else {
      api.reload('5754b456', component.options)
    }
    module.hot.accept("./mo-input-field.html?vue&type=template&id=5754b456&external", function () {
      api.rerender('5754b456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-input-field/mo-input-field.vue"
export default component.exports